import { ORG_MEMBER_ROLE_OWNER, ORG_MEMBER_ROLES, ORG_MEMBER_ROLES_CAN_CHANGE_MEMBERS } from '@constants'
import cn from 'clsx'

/**
 * 
 * @param {string} currentUserMemberRole - Role of the currently logged-in user
 * @param {User} member - Org member for this row
 * @param {function} onChangeMemberRole - Callback to change the member role
 * @returns {JSX.Element}
 * @constructor
 */
const MemberRoleSwitcher = ({
    currentUserMemberRole,
    member,
    onChangeMemberRole,
}) => {
    
    if (!ORG_MEMBER_ROLES_CAN_CHANGE_MEMBERS.includes(currentUserMemberRole)) return (
        <span className={cn('pl-3', {
            'text-accent': member.UserOrganizationJoin.memberRole === ORG_MEMBER_ROLE_OWNER,
        })}>
            {member.UserOrganizationJoin.memberRole}
        </span>
    )
    
    return (
        
        <select
            className={cn('select select-ghost select-sm w-full max-w-xs text-base', {
                'text-accent': member.UserOrganizationJoin.memberRole === ORG_MEMBER_ROLE_OWNER,
            })}
            value={member.UserOrganizationJoin.memberRole}
            onChange={onChangeMemberRole(member.id)}>
            
            {ORG_MEMBER_ROLES.map(role => (
                <option key={role} className="text-base">
                    {role}
                </option>
            ))}
        
        </select>
        
    )
    
}

export default MemberRoleSwitcher
